
import { PublicationsInfoModel } from '../models/PublicationsInfoModel.js';
import { PublicationsInfoView } from '../views/PublicationsInfoView.js';

export class PublicationsInfoController {
    constructor() {

        this.model = new PublicationsInfoModel();
        this.view = new PublicationsInfoView();

        this.model.subscribe(state => this.view.render(state));
    }
}